/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'gauge': {
    width: 22,
    height: 16,
    viewBox: '0 0 22 16',
    data: '<path pid="0" d="M11 0c6.065 0 11 4.934 11 11v5H0v-5C0 4.934 4.935 0 11 0ZM9.269 14h3.462c-.346-.597-.993-1-1.731-1-.738 0-1.384.403-1.731 1ZM20 14v-3c0-4.962-4.037-9-9-9s-9 4.038-9 9v3h5.143A3.993 3.993 0 0 1 10 11.142V7h2v4.142A3.997 3.997 0 0 1 14.857 14H20Zm-9-9a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm4.95 2.049a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM18 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2ZM6.05 7.051a1.001 1.001 0 1 1 0-2.002 1.001 1.001 0 0 1 0 2.002ZM4 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" _fill="#DDD" fill-rule="nonzero"/>'
  }
})
